module.exports = __webpack_public_path__ + "src/assets/img/listParam.20695e34.png";